<template>

<h2>{{ text }}</h2>

</template>

<script>

export default {

	props: ['text']

}

</script>

<style scoped>

h2 {
	color: #343434;
	font-size: 35px;
	line-height: 39px;
	font-weight: bold;
	margin-bottom: 48px;
	position: relative;
}

.is-patient h2:after {
	background-color: #F69B3B;
}

h2:after {
	content: ' ';
	background-color: #23CFFD;
	height: 4px;
	width: 120px;
	position: absolute;
	left: 0px;
	bottom: -16px;
}

.is-mobile h2 {
	font-size: 20px;
	line-height: 24px;
	margin-bottom: 38px;
}

</style>
